import { IHttpApi } from '@cian/http-api';
import { createSaveSurveyModel, ISaveSurveyRequest } from '../repositories/commercial-analytics/v1/save-survey';

export async function saveCommercialSurvey(httpApi: IHttpApi, parameters: ISaveSurveyRequest) {
  const { response, statusCode } = await httpApi.fetch(createSaveSurveyModel(parameters));

  if (statusCode === 200) {
    return response;
  }

  throw response;
}
